import React, { useState, useEffect } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@mui/styles";
import success from "../../assets/img/success.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import failed from "../../assets/img/failed.png";
import { adminGetTransferTypeList } from '../../redux/actions/adminGetTransferTypeListAction';
import { adminAddUpdateTransferType } from '../../redux/actions/adminAddUpdateTransferTypeAction';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation";

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminTransferType = () => {
    const classes = useStyles();

    const [selectedCountry, setselectedCountry] = useState('');
    const [transferTypeList, settransferTypeList] = useState([]);
    const [addModalOpen, setaddModalOpen] = useState(false);
    const [addSet, setaddSet] = useState(false);
    const [addDescription, setaddDescription] = useState('');
    const [notificationOpen, setnotificationOpen] = useState(false);
    const [addName, setaddName] = useState('');
    const [iaLoading, setiaLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [editOpen, seteditOpen] = useState(false);
    const [editTransferTypeName, seteditTransferTypeName] = useState('');
    const [editTransferTypeId, seteditTransferTypeId] = useState('');
    const [tableData, settableData] = useState([]);
    const [fetchInitiated, setFetchInitiated] = useState(false); // To track if initial fetch has been attempted

    const editHandleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'editTransferTypeName') {
            // seteditTransferTypeName(value);
            Util.alphaNumeric(value) ? seteditTransferTypeName(value) : seteditTransferTypeName(editTransferTypeName);
        }
        if (name === 'editTransferTypeId') {
            seteditTransferTypeId(value);
        }
    }

    const editSubmitFunc = () => {
        const addreq = {
            actionCustomerMasterRequestVO: {
                id: editTransferTypeId,
                name: editTransferTypeName
            }
        }
        dispatch(adminAddUpdateTransferType(addreq, authToken));
        setaddSet(true);
        seteditOpen(false);
    }

    const closeEditModal = () => {
        seteditOpen(false)
    }

    const addTransferTypeModalOpen = () => {
        setaddModalOpen(true);
    }

    const handleClose = () => {
        setaddModalOpen(false)
    }

    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'countryList') {
            setselectedCountry(value === 'Select Transfer Type' ? '' : value);
        }
    }

    const dispatch = useDispatch();

    useEffect(() => {
        getAllTransferType();
    }, [transferTypeList]);

    const getAllTransferType = () => {
        if (addSet) {
            if (adminAddUpdateTransferTypeRes.data.status === 'success') {
                settableData([].concat(adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList))
            }
            if (adminAddUpdateTransferTypeRes.data.status === 'failed') {
                if (
                    adminAddUpdateTransferTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateTransferTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
        setaddSet(false);
    }

    const searchCountryList = () => {
        setPage(0)
        transferTypeList.filter(ch => ch.name == selectedCountry ? ch : '').length == 0 ?
            settableData([].concat(transferTypeList)) : settableData([].concat(transferTypeList.filter(ch => ch.name == selectedCountry ? ch : '')));
    }

    useEffect(() => {
        searchCountryList()
    }, [])

    const adminGetTransferTypeListRes = useSelector(({ adminGetTransferTypeList }) => adminGetTransferTypeList);
    const adminAddUpdateTransferTypeRes = useSelector(({ adminAddUpdateTransferType }) => adminAddUpdateTransferType);
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    // var authToken = regenerateTokenRes.data.AuthToken;
    const authToken = regenerateTokenRes.data?.AuthToken;

    // useEffect(() => {
    //     getTransferTypeResp()
    // }, [adminGetTransferTypeListRes.data.status]);

    // const getTransferTypeList = () => {
    //     const req = {
    //         actionCustomerMasterRequestVO: {
    //             id: "",
    //             name: ""
    //         }
    //     }
    //     dispatch(adminGetTransferTypeList(req, authToken));
    // }

    // useEffect(() => {
    //     getTransferTypeList();
    // }, [])

    const respAddTransferType = () => {
        if (addSet) {
            if (adminAddUpdateTransferTypeRes.data.status === 'success') {
                setaddDescription(adminAddUpdateTransferTypeRes.data.description);
                // getTransferTypeResp();
                fetchTransferTypes()
                setnotificationOpen(true);
                // getTransferTypeList();
                // searchCountryList();
            }
            if (adminAddUpdateTransferTypeRes.data.status === 'failed') {
                setaddDescription(adminAddUpdateTransferTypeRes.data.description)
                setnotificationOpen(true);
                if (
                    adminAddUpdateTransferTypeRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    adminAddUpdateTransferTypeRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        respAddTransferType();
    }, [adminAddUpdateTransferTypeRes.data.status])

    // const getTransferTypeResp = () => {
    //     if (adminGetTransferTypeListRes.data.status === 'success') {
    //         settransferTypeList(adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList);
    //         searchCountryList();
    //         setiaLoading(false);
    //     }
    //     if (adminGetTransferTypeListRes.data.status === 'failed') {
    //         if (
    //             adminGetTransferTypeListRes.data.description == "session out"
    //         ) {
    //             SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //         if (
    //             adminGetTransferTypeListRes.data.description == "Authorization failed"
    //         ) {
    //             regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //         }
    //     }
    // }

    const addTransferTypeFunc = () => {
        setaddSet(true);
        const addreq = {
            actionCustomerMasterRequestVO: {
                id: '',
                name: addName
            }
        }
        dispatch(adminAddUpdateTransferType(addreq, authToken))
        setaddModalOpen(false);
        setaddName('');
    }

    const addInputChange = s => {
        const name = s.target.name;
        const value = s.target.value;
        if (name === 'addName') {
            // setaddName(value)
            Util.alphaNumeric(value) ? setaddName(value) : setaddName(addName);
        }
    }

    const handleNoticationClose = () => {
        setnotificationOpen(false)
        setaddDescription('')
    }

    const editModal = (id, name) => {
        seteditTransferTypeId(id)
        seteditTransferTypeName(name)
        seteditOpen(true);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Function to fetch transfer type list
    const fetchTransferTypes = () => {
        setiaLoading(true); // Set loading true when fetching
        const req = {
            actionCustomerMasterRequestVO: {
                id: "",
                name: ""
            }
        }
        dispatch(adminGetTransferTypeList(req, authToken));
    }

    // Effect for initial data fetch and re-fetch after token regeneration
    useEffect(() => {
        // Only initiate the first fetch if it hasn't been initiated yet
        if (!fetchInitiated) {
            fetchTransferTypes();
            setFetchInitiated(true);
        }
    }, [fetchInitiated]); // Dependency on fetchInitiated to control initial call

    // Effect to handle the response of adminGetTransferTypeList
    useEffect(() => {
        if (adminGetTransferTypeListRes.data.status === 'success') {
            settransferTypeList(adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList);
            searchCountryList(); // Re-run searchCountryList to update tableData
            setiaLoading(false);
        } else if (adminGetTransferTypeListRes.data.status === 'failed') {
            setiaLoading(false); // Stop loading on failure
            if (adminGetTransferTypeListRes.data.description === "session out") {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            } else if (adminGetTransferTypeListRes.data.description === "Authorization failed") {
                // Dispatch regenerateToken if Authorization failed
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }, [adminGetTransferTypeListRes.data.status, authToken, dispatch, regenerateTokenRes.data.partnerId]); // Added dependencies

    // Effect to re-fetch transfer types after successful token regeneration
    useEffect(() => {
        if (regenerateTokenRes.data.status === 'success' && adminGetTransferTypeListRes.data.description === "Authorization failed") {
            // If regenerateToken was successful and the previous transfer type fetch failed due to auth,
            // then re-fetch the transfer types with the new token.
            fetchTransferTypes();
        }
    }, [regenerateTokenRes.data.status, adminGetTransferTypeListRes.data.description]);

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1rem",
                            marginLeft: "1rem",
                            gap: "10px",
                            textAlign: "center"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={addTransferTypeModalOpen}
                            >
                                Add Transfer Type
                            </CustomButton>
                        </Grid>
                        <Grid item xs={12} md={3} sm={3} lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <NavLink to="/index/transferTypeMapping">
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}

                                >
                                    Mapping Transfer Type
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Transfer Type"
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Transfer Type"
                                    selected="Select Transfer Type"
                                >
                                    Select Transfer Type
                                </MenuItem>
                                {transferTypeList &&
                                    [].concat(transferTypeList).map((x) => (
                                        <MenuItem key={x.id} value={x.name}>
                                            {x.name}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={searchCountryList}
                            >
                                Search
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                <div>
                    <Dialog open={editOpen} onClose={closeEditModal}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Edit Transfer Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                disabled
                                variant='standard'
                                color="primary"
                                type="text"
                                label="Transfer Type Id"
                                fullWidth={true}
                                name="editTransferTypeId"
                                value={editTransferTypeId || ""}
                                onChange={editHandleChange}
                            ></TextField>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'

                                label="Transfer Type Name"
                                fullWidth={true}
                                name="editTransferTypeName"
                                value={editTransferTypeName || ""}
                                onChange={editHandleChange}
                            ></TextField>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={closeEditModal}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={editSubmitFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>

                <div>
                    <Dialog open={addModalOpen} onClose={handleClose}>
                        <DialogTitle style={{ minWidth: "600px" }}>
                            Add Transfer Type
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                required
                                style={{ marginTop: "10px" }}
                                size="small"
                                color="primary"
                                type="text"
                                variant='standard'
                                label="Transfer Type"
                                fullWidth={true}
                                name="addName"
                                value={addName || ""}
                                onChange={addInputChange}
                            ></TextField>
                        </DialogContent>
                        <DialogActions style={{ padding: "14px" }}>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{

                                    color: "white"
                                }}
                                variant="contained"
                                onClick={addTransferTypeFunc}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>

                {
                    iaLoading ? (<LoadingSpinner />) : tableData == undefined || !tableData || tableData.length == 0 ? (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Alert
                                        className="my-3 tableHeaderColor"
                                        variant="secondary"

                                        style={{ color: "white" }}
                                    >
                                        No Records Found!
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}
                                        className="themeText"

                                    >
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="my-3">
                                    <Table
                                        className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Transfer Type ID
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Transfer Type
                                                </TableCell>
                                                <TableCell
                                                    colSpan={2}
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {tableData &&
                                                []
                                                    .concat(tableData)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center"> {row.id} </TableCell>
                                                            <TableCell align="center"> {row.name} </TableCell>
                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() => editModal(row.id, row.name)}
                                                                >
                                                                    <EditIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(tableData).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    )
                }

            </Layout>
            {adminAddUpdateTransferTypeRes.data.status == "success" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {adminAddUpdateTransferTypeRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDescription}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminTransferType